import styled from 'styled-components';
import MaterialTextField from '@material-ui/core/TextField';

export const TextField = styled(MaterialTextField)`
  width: 100%;
`;
